import { Link } from "react-router-dom";
import { Caption1, makeStyles, tokens } from "@fluentui/react-components";

// The intnt wordmark is ~2.22:1 (2500×1125). Width is derived from height so
// callers only pick a height that fits their chrome.
const LOGO_RATIO = 2500 / 1125;

const useStyles = makeStyles({
  logo: {
    display: "block",
    width: "auto"
  },
  logoLink: {
    display: "inline-flex",
    alignItems: "center",
    textDecoration: "none"
  },
  footer: {
    marginTop: tokens.spacingVerticalXXXL,
    paddingTop: tokens.spacingVerticalL,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    textAlign: "center",
    color: tokens.colorNeutralForeground3
  }
});

/** The intnt wordmark as an <img>. Pass the desired pixel height. */
export function BrandLogo({ height = 28, alt = "intnt" }: { height?: number; alt?: string }) {
  const styles = useStyles();
  return (
    <img
      className={styles.logo}
      src="/brand/intnt-logo.png"
      alt={alt}
      height={height}
      width={Math.round(height * LOGO_RATIO)}
    />
  );
}

/** Clickable logo that routes home — used in the app header. */
export function BrandHome({ height = 26 }: { height?: number }) {
  const styles = useStyles();
  return (
    <Link to="/" className={styles.logoLink} aria-label="intnt Client Reporting — home">
      <BrandLogo height={height} />
    </Link>
  );
}

/** "powered by AdQuire" footer lockup for the main app chrome. */
export function BrandFooter() {
  const styles = useStyles();
  return (
    <footer className={styles.footer}>
      <Caption1>Client Reporting · powered by AdQuire</Caption1>
    </footer>
  );
}
